import DM from 'DM';
import Hub from '../hub.js';
import EventDelegate from '../utils/event-delegate.js';

const Selectors = {
    HEADER_PROFIL_CONTAINER: '.js-login-container',
    ACCOUNT_RELOAD_PAGE: '.js-login-reload-page',
    GOOGLE_BTN: '.js-google-login',
    GOOGLE_LOGIN_MESSAGE: '.js-google-login-message'
};

const Urls = {
    LOGON_GOOGLE: '/account/logongoogle'
};

class Account {
    constructor() {
        this.postLoginAction = () => { };

        this.subscribe();
        this.addEvents();
        this.fillPostAction();
    }

    subscribe() {
        Hub.subscribe(Hub.ACCOUNT_SHOW_LOGIN, () => {
            Hub.publish(Hub.PORTAL_OPEN, 'login');
        });

        Hub.subscribe(Hub.ACCOUNT_LOGIN_SUCCESS, () => {
            this.postLoginAction();
        });
    }

    loginSucessess() {
        Hub.publish(Hub.ACCOUNT_LOGIN_SUCCESS);
        Hub.publish(Hub.PORTAL_CLOSE);
    }

    fillPostAction() {
        const element = document.querySelector(Selectors.ACCOUNT_RELOAD_PAGE);

        if (element) {
            this.postLoginAction = function () {
                window.location.reload(false);
            };
        }
    }

    googleLoginResponseSuccess(result) {
        if (result && result.error) {
            const $googleMessage = document.querySelector(Selectors.GOOGLE_LOGIN_MESSAGE);
            if ($googleMessage) {
                $googleMessage.innerHTML = result.error;
            }
        } else {
            this.loginSucessess();
        }
    }

    googleLoginResponseHandler(idToken) {
        const $btn = document.querySelector(Selectors.GOOGLE_BTN);
        if (idToken) {
            const formData = new FormData();
            formData.append('token', idToken);

            fetch(Urls.LOGON_GOOGLE,
                {
                    method: 'POST',
                    body: formData
                })
                .then((result) => {
                    this.googleLoginResponseSuccess(result);
                })
                .catch(() => {
                    const $fbMessage = document.querySelector(Selectors.GOOGLE_LOGIN_MESSAGE);
                    if ($fbMessage) {
                        $fbMessage.innerHTML = 'Wystąpił błąd. Spróbuj ponownie.';
                    }
                })
                .finally(() => {
                    $btn.removeAttribute('disabled');
                });
        } else {
            $btn.removeAttribute('disabled');
        }
    }

    /**
     * @param {Event} event
     */
    googleLoginHandler(event) {
        const element = event.currentTarget;

        if (!element.disabled) {
            const $googleMessage = document.querySelector(Selectors.GOOGLE_LOGIN_MESSAGE);
            if ($googleMessage) {
                $googleMessage.innerHTML = '';
            }
            element.disabled = true;

            window._GoogleAuthSDK = () => {
                window.gapi.load('auth2',
                    () => {
                        window.gapi.auth2.init({
                            client_id: DM.Config.Google.clientId
                        }).then((auth2) => {
                            this.GoogleAuth = auth2;
                            this.googleLogin(element);
                        });
                    })
            }

            if (!DM.Utils.getCookie(DM.Cookies.KillTrackers) && !DM.Utils.killTracker('googlesdk')) {
                DM.LoadScript.register('https://apis.google.com/js/client:platform.js?onload=_GoogleAuthSDK', {
                    id: 'googleAuthSDK',
                    defer: true,
                });
            }
        }
    }

    googleLogin(element) {
        const auth = this.GoogleAuth;

        auth.signIn().then(() => {
            const idToken = auth.currentUser.get().getAuthResponse().id_token;
            this.googleLoginResponseHandler(idToken);
        }, () => {
            element.disabled = false;
        });
    }

    addEvents() {
        const delegate = new EventDelegate(document);

        delegate.on('click', Selectors.GOOGLE_BTN, this.googleLoginHandler.bind(this));
    }
}

DM.Module.Account = new Account();
